import { DataSource } from 'typeorm';
import { SQLiteService } from '../services/sqlite.service';
import {Pessoa} from "../domain/Pessoa";
import {InitializeAuthorPost1671880018001} from "./1671880018001-InitializeFauna";
import {Local} from "../domain/Local";
import {Bioma} from "../domain/Bioma";
import {Versao} from "../domain/Versao";
import {Taxon} from "../domain/Taxon";
import {Projeto} from "../domain/Projeto";
import {Campanha} from "../domain/Campanha";
import {MetodoAmostragem} from "../domain/MetodoAmostragem";
import {Arquivo} from "../domain/Arquivo";
import {Especime} from "../domain/Especime";
import {Fitofisionomia} from "../domain/Fitofisionomia";
import {Municipio} from "../domain/Municipio";
import {MicroRH} from "../domain/MicroRH";
import {CursoDagua} from "../domain/CursoDagua";
import {Monitoramento} from "../domain/Monitoramento";
import {Comportamento} from "../domain/Comportamento";
import {TipoMarcacao} from "../domain/TipoMarcacao";
import {MeteorologiaEspecime} from "../domain/MeteorologiaEspecime";
import {Jornada} from "../domain/Jornada";
import {Periodo} from "../domain/Periodo";
import {Droga} from "../domain/Droga";
import {UnidadeMedida} from "../domain/UnidadeMedida";

const sqliteService = new SQLiteService();
export const sqliteConnection = sqliteService.getSqliteConnection();

export default new DataSource({
  type: 'capacitor',
  driver: sqliteConnection,
  database: 'fauna',
  mode: 'no-encryption',
  entities: [ Local,Bioma,Versao,Taxon,Projeto, Droga, Pessoa, MetodoAmostragem, Campanha,Arquivo,Especime,Fitofisionomia
    ,UnidadeMedida,
  Municipio,MicroRH,CursoDagua,Monitoramento,Comportamento,TipoMarcacao,MeteorologiaEspecime,Jornada,Periodo],
  // migrations: [InitializeAuthorPost1671880018001],
  // migrations: [InitializeAuthorPost1671880018001,InitializeAuthorPost1671880018002],
  subscribers: [],
  // logging: [ 'error','schema'],
  logging: [ 'error','schema','query'],
  synchronize: false,
  migrationsRun: false,
});
